import './App.css';
import { useState } from "react"
import SubmitButton from './todo';

export default function Todo() {
    const[details,setDetails]=useState("")
    const[task,setTask]=useState([])
    const[errorr,setErrorr]=useState("")
    function changesDetails(e){
        setDetails(e.target.value)
        console.log(details);
    }
    function clickAdd(){
      if(details===""){
        setErrorr("pleace enter enything")
      }else{
        setErrorr("")
        setTask([...task,details])
      }
    }
    return (
        <div className="container">
            <h2>To-Do</h2>
            <div className="input-container">
                <input type="text" name="task" placeholder="Write Your Task" value={details}  onChange={changesDetails}/>
                <button onClick={clickAdd}>Add</button>
            </div>
            <p>{errorr}</p>
            <ul>
              <SubmitButton details={details} task={task} setTask={setTask}/>
            </ul>
        </div>
    )
}